import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, toast } from '../../../../../utils';
import axios from 'axios';

function getMonthYear(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: '2-digit' };
  return date.toLocaleDateString('en-GB', options);
}

const PRODUCT_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.main?.name
  }
];

const DETAIL_HEADER = [
  {
    header: 'Batch No',
    accessor: (row) => row?.batch_no
  },
  {
    header: 'Exp Date',
    accessor: (row) => getMonthYear(row.exp_date)
  },
  {
    header: 'Curr. Stock',
    accessor: (row) => row?.totalQuantity
  },
  {
    header: 'Unit Name',
    accessor: (row) => row?.unit_name
  },
  {
    header: 'Rate',
    accessor: (row) => row?.rate
  },
  {
    header: 'Sale Price',
    accessor: (row) => row?.mrp
  },
  {
    header: 'MRP',
    accessor: (row) => row?.mrp
  },
];

export const StockAdjustmentAddDetails = ({ onClose, chargeType = 'opd_charges', doctorID, onAdd, supplier }) => {
  const [grn, setGrn] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productDetails, setProductDetails] = useState([]);
  const [grnData, setGrnData] = useState([]);
  const [batch, setBatch] = useState('');
  const [productDropdown, setProductDropdown] = useState([]);
  const [input, setInput] = useState('');

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      current_stock : 0,
      adj_qty :0,
      new_qty :0,
      rate :0,
      new_rate:0,
      mrp:0,
      new_mrp:0,
      sale_price:0,
      new_sale_price :0,
      unit_cost :0,
      new_unit_cost :0,
    },
    mode: 'all'
  });

  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    const transformedValues = {
      ...formValues,
    };
    onAdd(transformedValues);
    reset();
  };


  const handleRowClick = (row) => {
    fetchStock(row?._id);
    setValue('product_name', row?.main.name);
    setValue('product',row?._id)

  };

const fetchStock = async (rowId) => {
  try {
    const response = await axios.get(`${BASE_URL}/stock-master/total?name=${rowId}`);
    if (response?.data?.success) {
      const productDetailsArray = response.data.data.map(item => ({
        ...item.productDetails,
        location: item.location, 
      }));
      setProductDetails(productDetailsArray);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setProductDetails([]); 
    }
  } catch (error) {
    toast('Error in fetching data', { variant: 'error' });
    setProductDetails([]); 
  }
};


  function formatToMonthInput(dateStr) {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  }

  useEffect(() => {
    console.log(productDetails, 'HELLLO PRODUCT DETAILS IS HERE');
  }, [productDetails]);




  const handleChange = (e) => {
    setInput(e.target.value);
  };

  useEffect(() => {
    const getProductDropdown = async (query) => {
      try {
        const lowercasedInput = query.toLowerCase();
        const response = await axios.get(`${BASE_URL}/product-master/dropdown?limit=50&name=${lowercasedInput}`);

        if (response.data.success) {
          setProductDropdown(response.data.data);
        } else {
          toast('Error in fetching data', { type: 'error' });
        }
      } catch (error) {
        toast('Network error while fetching data', { type: 'error' });
        console.error(error);
      }
    };
    getProductDropdown(input);
  }, []);

  useEffect(() => {
    if (input) {
      const getProductDropdown = async () => {
        try {
          const lowercasedInput = input.toLowerCase();
          const response = await axios.get(`${BASE_URL}/product-master/dropdown?limit=50&name=${lowercasedInput}`);

          if (response.data.success) {
            setProductDropdown(response.data.data);
          } else {
            toast('Error in fetching data', { type: 'error' });
          }
        } catch (error) {
          toast('Network error while fetching data', { type: 'error' });
          console.error(error);
        }
      };
      getProductDropdown();
    }
  }, [input]);

const handleProductClicks = (row) => {
  console.log(row, "HELLO ROW IS HERE ...");
  setValue('batch_no', row?.batch_no);
  if (row?.exp_date) {
    const date = new Date(row.exp_date);
    const formattedDate = date.toISOString().slice(0, 7); 
    setValue('exp_date', formattedDate);
  } else {
    setValue('exp_date', ''); 
  }
  setValue('current_stock',row?.totalQuantity)
  setValue('mrp',row?.mrp)
  setValue('rate',row?.rate)
  setValue('sale_price',row?.mrp)
  setValue('location',row?.location._id)
  setValue('location_name',row?.location?.location)
};

const watchCurrentStock = watch('current_stock')
const watchAdjQty = watch('adj_qty')

  useEffect(() => {
    const sum = (parseFloat(watchCurrentStock) || 0) + (parseFloat(watchAdjQty) || 0);
    setValue('new_qty', sum);
  }, [setValue,watchAdjQty]);

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container sx={{ height: '100vh' }}>
          <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ flex: 1, p: 2, overflow: 'auto' }}>
              <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
                <MuiTextField
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      padding: '0',
                      fontSize: '1.4rem'
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '8px 1.4rem'
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '1.2rem'
                    }
                  }}
                  label="Search Products"
                  variant="outlined"
                  value={input}
                  onChange={handleChange}
                />
              </Stack>
              <Table
                containerSX={{ height: '100%', border: '1px solid rgba(0,0,0,0.27)', minHeight: '50rem' }}
                data={productDropdown || []}
                columns={PRODUCT_HEADER}
                size="small"
                onRowClick={handleRowClick}
              />
            </Box>
          </Grid>
          <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Product Name</Typography>
              <TextField sx={{ flex: 1 }} name="product_name" placeholder="Select Product" disabled />
            </Stack>
            <Table
              containerSX={{ height: '100%', border: '1px solid rgba(0,0,0,0.27)' }}
              data={productDetails || []}
              columns={DETAIL_HEADER}
              size="small"
              onRowClick={handleProductClicks}
            />

            <Stack direction="row" alignItems="center">
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Batch No</Typography>
              <TextField sx={{ flex: 0.4 }} name="batch_no" placeholder="Batch No" disabled />
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Exp. Date</Typography>
              <TextField sx={{ flex: 0.4 }} name="exp_date" type="month" disabled/>
            </Stack>

            <Stack direction="row" alignItems="center">
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Current Stock</Typography>
              <TextField sx={{ flex: 0.4 }} name="current_stock" placeholder="Current Stock" type="number" disabled />
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Adjust Qty</Typography>
              <TextField sx={{ flex: 0.4 }} name="adj_qty" placeholder="Adjust Qty." type="number" />
            </Stack>

            <Stack direction="row" alignItems="center">
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>New Qty</Typography>
              <TextField sx={{ flex: 0.4 }} name="new_qty" placeholder="New Qty" type="number" disabled/>
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Unit Name</Typography>
              <TextField sx={{ flex: 0.4 }} name="unit_name" placeholder="Unit Name" disabled/>
            </Stack>

            <Stack direction="row" alignItems="center">
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
              <TextField sx={{ flex: 0.4 }} name="rate" placeholder="Rate" type="number" disabled />
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>MRP</Typography>
              <TextField sx={{ flex: 0.4 }} name="mrp" placeholder="MRP" type="number" disabled />
            </Stack>

            <Stack direction="row" alignItems="center">
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Sale Price</Typography>
              <TextField sx={{ flex: 0.4 }} name="sale_price" placeholder="Sale Price" type="number"  disabled/>
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Unit Cost </Typography>
              <TextField sx={{ flex: 0.4 }} name="unit_cost" placeholder="Unit Cost" type="number" disabled/>
            </Stack>

            <Stack direction="row" alignItems="center">
              <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>Reason</Typography>
              <TextField sx={{ flex: 1 }} name="reason" placeholder="Enter Reason" />
            </Stack>
            {/* Buttons */}
            <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{ mt: 2 }}>
              <Button variant="contained" type="submit">
                Add
              </Button>
              <Button variant="outlined" onClick={onClose} color="error">
                Close
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
